import Header from "../../components/header/Header";
import "./profile.css";
import { useEffect, useState } from "react";
import ReviewerService from "../../services/reviewer.service";
import Preloader from "../../components/preloader/Preloader";

const ReviewerProfile = () => {
	const [fetching, setFetching] = useState(false);
	const [user, setUser] = useState(null);
	const [totalRequest, setTotalRequest] = useState(null);
	const [totalApproved, setTotalApproved] = useState(null);
	const [totalDenied, setTotalDenied] = useState(null);

	const getProfileData = async () => {
		setFetching(true);
		let res = await ReviewerService.getReviewerBoard();
		setUser(res.user);
		setTotalRequest(res.totalNumProject);
		setTotalApproved(res.totalApproved);
		setTotalDenied(res.totalDenied);
		setFetching(false);
	};

	useEffect(() => {
		getProfileData();
	}, []);

	const currentUserRoles = (user) => {
		return user.map((role) =>
			role.name === "reviewer"
				? "REVIEWER"
				: role.name === "initiator"
				? "INITIATOR"
				: role.name === "admin"
				? "ADMIN"
				: role.name === "approver"
				? "APPROVER"
				: "USER",
		);
	};

	return (
		<div className="action__page">
			<Header />
			{user && (
				<>
					<div className="profile__page__heading">MY PORTFOLIO</div>
					<div className="profile__role">
						<div className="profile__card-heading">
							{user.firstname}.{user.lastname}
						</div>
						<div className="profile__card-heading">
							ROLE: {currentUserRoles(user.roles)}
						</div>
					</div>
					<div className="profile__card">
						<div className="profile__card-items">
							<div className="profile__card-item card__left">
								<p>
									<span style={{ color: "#901919" }}>STAFF NUMBER:</span>
									<span>{user.staffnum}</span>
								</p>
								<p>
									<span style={{ color: "#901919" }}>EMPLOYMENT DATE:</span>
									<span>{user.employmentDate}</span>
								</p>
								<p>
									<span style={{ color: "#901919" }}>EMPLOYMENT LOCATION:</span>
									<span>{user.employmentLocation}</span>
								</p>
								<p>
									<span style={{ color: "#901919" }}>GRADE:</span>
									<span>LEVEL {user.grade}</span>
								</p>
								<p>
									<span style={{ color: "#901919" }}>STATE OF ORIGIN:</span>
									<span>{user.stateOfOrigin}</span>
								</p>
								<p>
									<span style={{ color: "#901919" }}>TOTAL PROJECT:</span>
									<span>{totalRequest}</span>
								</p>
								<p>
									<span style={{ color: "#901919" }}>TOTAL APPROVED:</span>
									<span>{totalApproved}</span>
								</p>
								<p>
									<span style={{ color: "#901919" }}>TOTAL DENIED:</span>
									<span>{totalDenied}</span>
								</p>
							</div>
							<div className="profile__card-item card__right">
								<p>
									<span style={{ color: "#901919" }}>JOB TITLE:</span>
									<span>{user.jobTitle}</span>
								</p>
								<p>
									<span style={{ color: "#901919" }}>EMAIL ADDRESS:</span>
									<span className="profile__email">{user.email}</span>
								</p>
								<p>
									<span style={{ color: "#901919" }}>PHONE NUMBER:</span>
									<span>{user.phone}</span>
								</p>
								<p>
									<span style={{ color: "#901919" }}>DEPARTMENT:</span>
									<span>{user.department}</span>
								</p>
								<p>
									<span style={{ color: "#901919" }}>PENCOM NUMBER:</span>
									<span>{user.pencomNumber}</span>
								</p>
								<p>
									<span style={{ color: "#901919" }}>NHF:</span>
									<span>{user.nhf}</span>
								</p>
								<p>
									<span style={{ color: "#901919" }}>LOCAL GOVT:</span>
									<span>{user.localGovt}</span>
								</p>
								<p>
									<span style={{ color: "#901919" }}>DATE OF BIRTH:</span>
									<span>{user.dateOfBirth}</span>
								</p>
							</div>
						</div>
					</div>
				</>
			)}
			{fetching && <Preloader text={"Fetching data"} />}
		</div>
	);
};

export default ReviewerProfile;
